import React from 'react';

interface Props {
  title: string;
  disabled?: boolean;
  onClick: () => void;
  isActive: boolean;
}
export const HeaderTab = (props: Props) => {
  const { title, disabled, onClick, isActive } = props;
  return (
    <div
      className={`font-semibold flex-1 flex items-center justify-center border-solid border-0 
    ${isActive && 'border-b-2 border-[#006AF5] text-[#006AF5]'}`}
      onClick={disabled ? null : onClick}
    >
      {' '}
      {title}{' '}
    </div>
  );
};
